// import style
import './Button.css';

const Button = ({children, className, isLoading, canSave, onClick, id}) => {
  return (
   <button className={`${className} btn popup_button
    ${!canSave && "disable_btn"}`} type='submit' id={id}
    disabled={!canSave || isLoading} onClick={onClick}>
        {isLoading ? <div className='btn_loader'/>:children}
    </button>
  )
}

export default Button